import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[contextMenu]',
    standalone: false,
})
export class ContextMenuDirective {
    @HostBinding('class') elementClass = 'context-menu mat-elevation-z2';
}
